import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCrop: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="crop"><path d="M16 8H8V16H16V8Z" fill="currentColor"/><path fillRule="evenodd" clipRule="evenodd" d="M5.75 2C6.16421 2 6.5 2.33579 6.5 2.75V5H18.25C18.6642 5 19 5.33579 19 5.75V17.5H21.25C21.6642 17.5 22 17.8358 22 18.25C22 18.6642 21.6642 19 21.25 19H19V21.25C19 21.6642 18.6642 22 18.25 22C17.8358 22 17.5 21.6642 17.5 21.25V19H5.75C5.33579 19 5 18.6642 5 18.25V6.5H2.75C2.33579 6.5 2 6.16421 2 5.75C2 5.33579 2.33579 5 2.75 5H5V2.75C5 2.33579 5.33579 2 5.75 2ZM6.5 17.5V6.5H17.5V17.5H6.5Z" fill="currentColor"/></CentralIconBase>;
};

export default IconCrop;
